export const DEFAULT_CONFIG_STRINGS: Record<string, string> = {
  // QuestModal text
  config_quest_mission_completed:
    "✅ You have successfully completed this mission. Great job!",
  config_quest_mission_starting: "💡 Starting mission...",
  config_quest_mission_completing: "⏳ Completing mission...",
  config_quest_mission_no_attempt:
    "⚠️ Error: Could not complete the mission. Try starting it again.",
  config_quest_mission_error:
    "❌ Error completing the mission. Please try again.",
  config_quest_mission_start_error:
    "❌ Error starting the mission. Please try again.",
  config_quest_mission_started: "📢 Mission started successfully",
  config_button_submitting: "⏳ Starting...",
  // SoonImageCard text
  config_notify_success: "You'll be notified when this quest is available!",
  config_notify_error:
    "❌ There was an error subscribing to this quest. Please try again later.",
  config_notify_already_subscribed:
    "📝 You're already on the waitlist for this quest!",
  config_unsubscribe_success:
    "Successfully unsubscribed from quest notifications",
  config_unsubscribe_error: "Error unsubscribing from quest. Please try again.",
  // Loading and error states
  config_quests_loading: "Loading Quests…",
  config_error_quests: "❌ Error loading quests. Please try again later.",
  config_no_quests_available:
    "📭 No quests are currently available. Check back soon!",
  // Navigation bar text
  config_nav_profile: "👤 User Profile",
  // Quest detail page
  config_quest_mark_completed: "✓ Mark as completed",
  config_profile_title: "👤 User Profile",
  config_profile_name_label: "Full name",
  config_profile_name_placeholder: "Enter your full name",
  config_profile_email_label: "Email",
  config_profile_email_placeholder: "Enter your email",
  config_profile_password_label: "Password",
  config_profile_password_description:
    "Update the password you use to access your account.",
  config_profile_password_title: "Update password",
  config_profile_new_password_label: "New password",
  config_profile_password_placeholder: "Enter your current password",
  config_profile_new_password_placeholder: "Enter your new password",
  config_profile_button_update: "Update",
  config_profile_button_back: "Back",
  config_profile_password_changed_success:
    "✅ Password updated successfully. Logged out of other browsers.",
  config_profile_password_validation_min: "At least 8 characters",
  config_profile_password_validation_number: "At least one number",
  config_profile_password_validation_special: "At least one special character",
  config_profile_password_validation_uppercase: "At least one uppercase letter",
  config_profile_password_validation_lowercase: "At least one lowercase letter",
  config_profile_error_fields_required: "Please complete all fields",
  config_profile_error_invalid_password: "Invalid password",
  config_profile_error_generic:
    "⚠️ An error occurred while updating password. Please try again later.",
  config_login_sign_up: "Already an account? [Sign up]({url})",
  config_login_forgot_password: "Forgot password?",
  config_login_error_generic: "⚠️ An error occurred. Please try again later.",
  config_login_error_credentials:
    "⚠️ Email and password combination doesn't match.",
  config_login_layout_description:
    "Empower your tween with engaging, bite-sized missions designed to cultivate wisdom for tackling both online and real-world challenges.",
  config_user_profile_settings_description_all_disabled:
    "All email notifications are currently disabled. You will still receive important account-related emails for security purposes.",
  config_user_profile_settings_email_title: "Email notification settings",
  config_user_profile_settings_quest_progress: "Quest progress",
  config_user_profile_settings_quest_progress_desc:
    "If you want to keep an eye on your quest from your inbox.",
  config_user_profile_settings_reminders: "Reminders",
  config_user_profile_settings_reminders_desc:
    "We can send you messages so you maintain your learning streak.",
  config_user_profile_settings_new_features: "New features",
  config_user_profile_settings_new_features_desc:
    "Product updates and new quests. We'll let you know when something cool arrives.",
  config_user_profile_settings_account_info: "Account information",
  config_user_profile_settings_account_info_desc:
    "Important emails about your account security, password changes, and other critical updates.",
  config_account_title: "Account",
  config_notifications_title: "Notifications",
  config_markdown_callout_note: "Pandora's Note",
  config_mission_resource_title: "📚 Mission resources",
  config_mission_delete_account: "Delete my account",
  config_mission_delete_account_confirmation: "Delete",
  config_profile_delete_account_title:
    "Are you sure you want to delete your account?",
  config_profile_delete_account_warning:
    "Deleting your account cannot be undone. Do you want to proceed?",
  config_profile_delete_account_cancel: "Cancel",
  config_onboarding_slide_1_content:
    "## Welcome to Pandora's Way\n\nParenting in today’s digital world isn’t simple, and no one has all the answers from above. We believe change starts with families and communities like yours. Our mission is to help you protect mental health, nurture identity, and build belonging… while giving you tools to make thoughtful choices along the way.",
  config_onboarding_slide_2_content:
    "## Quests and Missions\n\nWe’ve built Quests to give families clear, structured ways to face digital challenges. Each Quest is made up of Missions: practical activities that take about 20 minutes and fit into everyday life. Most start with a conversation between you and your child, helping you strengthen your connection and healthy habits.",
  config_onboarding_slide_3_content:
    "## Every family is unique\n\nNo two families are the same, and your path shouldn’t be either. From time to time, we’ll ask you quick questions so we can shape Quests and Missions around your needs. And if you ever have ideas or feedback, we’re always just an email away at [support@pandorasway.com](mailto:support@pandorasway.com)",
  config_onboarding_button_continue: "Continue",
  config_onboarding_button_finish: "Finish",
  config_mission_loading: "Loading mission…",
  config_mission_button_back: "Back",
  config_quiz_next_button: "Continue",
  config_quiz_restart_button: "Restart quiz",
  config_quiz_loading_result: "Loading your result...",
  config_quiz_back_button: "Back",
  config_navigation_button_signup: "Sign up",
  config_mission_button_signup: "Sign up",
  config_sign_up_email_not_received:
    " Haven't received anything? this usually can take some seconds, also check you spam to be sure you don't have received the confirmation email or try again",
  config_button_quest_unsubscribe: "Unsubscribe",
  config_mission_button_see: "See completed mission",
  config_mission_button_next: "Next mission",
  config_mission_button_start_next: "Start next mission",
  config_mission_button_starting: "Starting…",
  config_button_start_mission: "Start mission",
  config_mission_button_start: "Start mission",
  config_mission_button_sending: "Sending…",
  config_404_message: "Looks like this page doesn't exist",
  config_404_button: "Back to home",
  config_unsubscribe_title: "You are unsubscribed",
  config_unsubscribe_message: "If you want to turn them back on, go to",
  config_unsubscribe_link_text: "your profile settings",
  config_share_message: "Check out this on Pandora's Way: {missionName}",
  config_share_success: "Shared successfully!",
  config_share_sharing: "Sharing…",
  config_share_button: "Share",
  config_share_link_copied: "Link copied to clipboard",
  config_share_mission_title: "Share this mission",
  config_share_choose_method: "Choose how you want to share",
  config_share_copy_link: "Copy link",
  config_share_copied: "Copied",
  config_share_copy: "Copy",
  config_share_social_title: "Share on social media",
  config_form_error_summary_single: "{fields} has an error",
  config_form_error_summary_multiple: "{fields} have errors",
  config_form_error_summary_instruction:
    "Please check the fields marked above and correct the errors.",
  config_question_button_skip: "Skip",
  config_question_text_placeholder: "Enter your answer…",
  config_mission_estimate_label_prep_time: "Prep. time",
  config_mission_estimate_label_action_time: "Action time",
  config_journey_progress: "Progress {journeyProgress}%",
  config_sign_up_hero_description:
    "Empower your tween with engaging, bite-sized missions designed to cultivate wisdom for tackling both online and real-world challenges.",
  // AuthLayout descriptions
  config_forgot_password_email_description:
    "📧 We've sent you an email with instructions to reset your password. Please check your inbox and follow the link to continue.",
  config_forgot_password_description:
    "🔐 Enter your email address and we'll send you a link to reset your password. Don't worry, it happens to the best of us!",
  config_reset_password_description:
    "🆕 Create a new password for your account. Make sure it's strong and secure to keep your account protected.",
  config_reset_password_success_description:
    "🎉 Your password has been successfully reset! You can now log in with your new password.",
}
